module.exports = __webpack_public_path__ + "static/media/selectedConnection.b397ca63.svg";